import { useState } from "react";

import analytics from "@react-native-firebase/analytics";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";

import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import { getActiveStep } from "@microdoing/shared/services/userCampaign/selectors";
import i18n from "@microdoing/shared/i18n";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  modifyUser,
  updateUserWithoutResponseRequest,
} from "@microdoing/shared/services/user/actions";

import selectLanguage from "@microdoing/shared/utils/selectLanguage";
import removeHtmlTags from "@microdoing/shared/utils/removeHtmlTags";
import theme from "app/Theme/Theme";
import * as AddCalendarEvent from "react-native-add-calendar-event";
import { showAlert } from "@microdoing/shared/services/profileSettings/actions";
import askPermissionAgain from "./askPermissionAgain";

const utcDateToString = momentInUTC => {
  let s = moment.utc(momentInUTC).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  return s;
};

export const useAddCalendarEvent = () => {
  const [utcTime, setUtcTime] = useState(moment.utc());

  const language = useSelector(getLanguage);
  const item = useSelector(getActiveStep);

  const dispatch = useDispatch();

  const openCalendar = async () => {
    try {
      if (!isWeb) {
        analytics().logEvent("click_add_calendar");
      }
      setUtcTime(moment.utc());
      await AddCalendarEvent.presentEventCreatingDialog({
        title:
          i18n.t("title-calendar") +
          removeHtmlTags(selectLanguage({ text: item?.title, language })),
        startDate: utcDateToString(moment.utc(utcTime).add(1, "days")),
        endDate: utcDateToString(
          moment.utc(utcTime).add(1, "days").add(10, "minutes"),
        ),
        notes: removeHtmlTags(
          selectLanguage({ text: item?.content?.title, language }),
        ),
        alert: 5,
        navigationBarIOS: {
          translucent: false,
          tintColor: theme.colors["brand.500"],
          barTintColor: theme.colors["neutral.50"],
          backgroundColor: theme.colors["neutral.white"],
          titleColor: theme.colors["neutral.900"],
        },
        url: "https://links.microdoing.com/store/MZ8A",
      })
        .then(eventInfo => {
          // IOS => { action: 'SAVED', eventIdentifier: string, calendarItemIdentifier: string }, { action: 'CANCELED' }
          // Android => { action: 'SAVED', eventIdentifier: string, calendarItemIdentifier: string }, { action: 'CANCELED' }
          if (eventInfo.action == "CANCELED") {
            // dispatch(
            //   showAlert({
            //     title: i18n.t("reminder-save-calendar-cancel-title"),
            //     message: i18n.t("reminder-save-calendar-cancel-message"),
            //     alertType: AlertType.ERROR,
            //   }),
            // );
          } else {
            //eventId = eventInfo?.eventIdentifier; // que faire avec les event calendar

            if (!isWeb) {
              analytics().logEvent("add_calendar_success");
            }
            dispatch(
              showAlert({
                title: i18n.t("reminder-save-calendar-success-title"),
                message: i18n.t("reminder-save-calendar-success-message"),
              }),
            );
          }
        })
        .catch(error => {
          // if permission not granted => demander la permission
          askPermissionAgain({
            alertMessage: i18n.t("alert-ask-permission-message-calendar"),
          });
        });
    } catch (e) {
      console.log(e);
    }
  };

  return [openCalendar];
};
